import { Field } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledSkus = styled.div``

export const SkuType = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: 0.5rem;
`

export const Checkbox = styled(Field.Checkbox)``
